import { Type } from "class-transformer";

export default class Invitation {
  activationUrl: string;
  @Type(() => Date)
  expiresAt: Date;
}
